export const Bio = {
  name: "Amal E A",
  roles: [
    "Full Stack Developer",
    "Web Developer",
    // "Android Developer",
    // "UI/UX Designer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Amal911",
  resume:"https://drive.google.com/file/d/1zYOQVvkWB3AgejtkMe6NfNwuyCrHKOnm/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/amal-e-a-812464246/",
  twitter: "https://twitter.com/AmalEA911",
  insta: "https://www.instagram.com/__.e_a.__/",
  facebook: "",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      // {
      //   name: "Redux",
      //   image:
      //     "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      // },
      // {
      //   name: "Next Js",
      //   image:
      //     "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      // },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      // {
      //   name: "Material UI",
      //   image:
      //     "data:image/png;base64,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",
      // },
      // {
      //   name: "Flutter",
      //   image:
      //     "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      // },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      // {
      //   name: "Graph Ql",
      //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      // },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      // {
      //   name: "Postgresql",
      //   image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      // },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      // {
      //   name: "Firebase",
      //   image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      // },
    ],
  },
  // {
  //   title: "Android",
  //   skills: [
  //     {
  //       name: "Java",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Kotlin",
  //       image:
  //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
  //     },
  //     {
  //       name: "XML",
  //       image:
  //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
  //     },
  //     {
  //       name: "Android Studio",
  //       image:
  //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
  //     },
  //   ],
  // },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      // {
      //   name: "Docker",
      //   image:
      //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      // },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
      },
      // {
      //   name: "Adobe XD",
      //   image:
      //     "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      // },
      // {
      //   name: "Figma",
      //   image:
      //     "https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
      // },
    ],
  },
];

export const experiences = [
  {
    id: 1,
    img: "https://media.licdn.com/dms/image/D560BAQEioj55ExlKcw/company-logo_200_200/0/1693145853908?e=1708560000&v=beta&t=I1l4ZihoA4YOUz2IW2ZuHo_LtQ1H8TrSkzNgN89Gg4g",
    role: "Software Developer Intern",
    company: "Composolution",
    date: "Nov 2023 - present",
    desc: "Working on FrontEnd, BackEnd and Database connection of a website using Codeigniter 4",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "PHP",
      "Codeigniter 4",
      "MySql",
    ],
  },
  {
    id: 0,
    img: "https://cdn.dribbble.com/users/2059160/screenshots/4413086/day20-freelance.jpg",
    role: "Freelance Web Developer",
    company: "",
    date: "Aug 2023 - present",
    desc: "Started my Freelance journey on Web Development",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "React Js",
      "Node Js",
      "Bootstrap",
      "Express Js",
      "Mongo DB",
      "MySQL",
    ],
    doc: "",
  },

];

export const education = [
  {
    id: 0,
    img: "https://ktu.edu.in/static/media/logo_header.77120c09.png",
    school: "APJ Abdul Kalam Technological University",
    date: "2019 - 2023",
    grade: "7.77 CGPA",
    desc: "Graduated Bachelor's degree in Computer Science and Engineering at Universal Engineering College, Thrissur under APJ Abdul Kalam Technological University",
    degree: "Bachelor of Technology (BTech) in Computer Science and Engineering",
  },
  {
    id: 1,
    img: "",
    school: "MES Public School",
    date: "2017-2019",
    grade: "75%",
    desc: "Completed my class 12 high school education at MES Public School, Kodungallur, where I studied Computer Science.",
    degree: "CBSE(XII), Computer Science",
  },
  {
    id: 2,
    img: "",
    school: "MES Public School",
    date: "2017",
    grade: "CGPA 10",
    desc: "Completed my class 10 education at MES Public School, Kodungallur.",
    degree: "CBSE",
    
  },
];

export const projects = [
  {
    id: 5,
    title: "Trekking Travels",
    date: "",
    description:
      "Trecking Travelss is a travels company landing page .",
    image:
      "https://github.com/Amal911/Trekking-Travel/raw/main/source/images/preview.png",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "Bootstrap",
    ],
    category: "web design",
    github: "https://github.com/Amal911/Trekking-Travel",
    webapp: "https://amal911.github.io/Trekking-Travel/",
  },
  {
    id: 4,
    title: "Health Crew",
    date: "",
    description:
      "website build for Health Crew.click a fitness program.",
    image:
      "https://github.com/Amal911/HealthCrew/raw/main/assets/images/health%20crew.png",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "Bootstrap",
    ],
    category: "web design",
    github: "https://github.com/healthcrewclick/healthcrewclick.github.io",
    webapp: "https://healthcrewclick.github.io/",
    member: [
      {
        name: "Amal E A",
        img: "https://avatars.githubusercontent.com/u/115872951?v=4",
        linkedin: "https://www.linkedin.com/in/amal-e-a-812464246/",
        github: "https://github.com/Amal911",
      },
   
      {
        name: "Mohammed Rasnal K A",
        img: "https://avatars.githubusercontent.com/u/59244980?s=100&v=4",
        linkedin: "https://www.linkedin.com/in/mohammed-rasnal-k-a-373508221/",
        github: "https://github.com/raznalrich",
      },
      
    ],
  },
  {
      id: 3,
      title: "SARA: The virtual Receptionist",
      date: "",
      description:
        "SARA is a virtual receptionist built to serve at college reception. the application have features such as Face Recognition, Attendance Marking, Navigation, Visitor Notification etc. The project is built as part of BTech Final year major project ",
      image:
        "https://github.com/Amal911/SARA-A-college-Receptionist/raw/master/SARA%20A%20Virtual%20Receptionist.png",
      tags: ["Python", "Django", "SQlite", "HTML", "CSS", "JavaScript", "OpenCV", ],
      category: "web app",
      github: "https://github.com/Amal911/SARA-A-college-Receptionist",
      webapp: "https://github.com/Amal911/SARA-A-college-Receptionist",
      member: [
        {
          name: "Amal E A",
          img: "https://avatars.githubusercontent.com/u/115872951?v=4",
          linkedin: "https://www.linkedin.com/in/amal-e-a-812464246/",
          github: "https://github.com/Amal911",
        },
        {
          name: "Maxen Varghese",
          img: "https://avatars.githubusercontent.com/u/64342680?s=100&v=4",
          linkedin: "https://www.linkedin.com/in/maxenvarghese/",
          github: "https://github.com/Maxen16",
        },
        {
          name: "Mohammed Rasnal K A",
          img: "https://avatars.githubusercontent.com/u/59244980?s=100&v=4",
          linkedin: "https://www.linkedin.com/in/mohammed-rasnal-k-a-373508221/",
          github: "https://github.com/raznalrich",
        },
        {
          name: "Rohith Sekhar N",
          img: "https://avatars.githubusercontent.com/u/96624609?s=100&v=4",
          linkedin: "https://www.linkedin.com/in/rohith-sekhar-n-a9922b22b/",
          github: "https://github.com/RohithSekharN",
        },
      ],
    },
    {
      id: 2,
      title: "Guess The Dice Game",
      date: "",
      description:
        "A simple ReactJS application game in which you collects points if you guess the dice roll correctly",
      image: "https://github.com/Amal911/Dice-Game/raw/main/public/DiceGame.png",
      tags: ["ReactJS", "JavaScript", "Styled Components"],
      category: "web app",
      github: "https://github.com/Amal911/Dice-Game",
      webapp: "https://dice-game-amal911.netlify.app/",
    },
    {
      id: 1,
      title: "Quick Notes",
      date: "",
      description:
        "Quick Notes is a Web App mate to store notes. It is a clone of Google's Keep Notes. The apllication is made with NodeJS as the backend and MongoDB as the Database. ",
      image:
        "https://github.com/Amal911/Quick-Notes/raw/main/public/img/img.png",
      tags: [
        "HTML",
        "CSS",
        "EJS",
        "JavaScript",
        "NodeJS",
        "ExpressJS",
        "MongoDB",
      ],
      category: "web app",
      github: "https://github.com/Amal911/Quick-Notes",
      webapp: "",
    },
  {
      id: 2,
      title: "Pneumonia Detection System",
      date: "",
      description:
        "Pneumonia Detection System is an Web Application used for detecting pneumonia using chest X-Ray scan image. A ML model was traned using keras dataset and is used for pneumonia detection. The project was done as a part of BTech Mini Project",
      image:
        "",
      tags: ["Python", "TensorFow", "OpenCV", "Keras"],
      category: "web app",
      github: "",
      webapp: "",
      member: [
        {
          name: "Amal E A",
          img: "https://avatars.githubusercontent.com/u/115872951?v=4",
          linkedin: "https://www.linkedin.com/in/amal-e-a-812464246/",
          github: "https://github.com/Amal911",
        },
        {
          name: "Maxen Varghese",
          img: "https://avatars.githubusercontent.com/u/64342680?s=100&v=4",
          linkedin: "https://www.linkedin.com/in/maxenvarghese/",
          github: "https://github.com/Maxen16",
        },
        {
          name: "Mohammed Rasnal K A",
          img: "https://avatars.githubusercontent.com/u/59244980?s=100&v=4",
          linkedin: "https://www.linkedin.com/in/mohammed-rasnal-k-a-373508221/",
          github: "https://github.com/raznalrich",
        },
        {
          name: "Rohith Sekhar N",
          img: "https://avatars.githubusercontent.com/u/96624609?s=100&v=4",
          linkedin: "https://www.linkedin.com/in/rohith-sekhar-n-a9922b22b/",
          github: "https://github.com/RohithSekharN",
        },
      ],
    },
  
  {
    id: 0,
    title: "Face Recognition System",
    date: "",
    description:
      "A Face recognition python proram made with OpenCV. It uses face_recognition library and kNN Classifier for model training, face recognition and classification",
    image:
      "",
    tags: ["Python", "TensorFlow", "kNN Classifier", "Pickle", "OpenCV"],
    category: "machine learning",
    github: "https://github.com/Amal911/Face_Recognition_Using_KNN",
    webapp: "https://github.com/Amal911/Face_Recognition_Using_KNN",
  },

];




export const projectHighlights = [
  {
    id: 5,
    title: "Trekking Travels",
    date: "",
    description:
      "Trecking Travelss is a travels company landing page .",
    image:
      "https://github.com/Amal911/Trekking-Travel/raw/main/source/images/preview.png",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "Bootstrap",
    ],
    category: "web design",
    github: "https://github.com/Amal911/Trekking-Travel",
    webapp: "https://amal911.github.io/Trekking-Travel/",
  },
  {
    id: 4,
    title: "Health Crew",
    date: "",
    description:
      "website build for Health Crew.click a fitness program.",
    image:
      "https://github.com/Amal911/HealthCrew/raw/main/assets/images/health%20crew.png",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "Bootstrap",
    ],
    category: "web design",
    github: "https://github.com/healthcrewclick/healthcrewclick.github.io",
    webapp: "https://healthcrewclick.github.io/",
    member: [
      {
        name: "Amal E A",
        img: "https://avatars.githubusercontent.com/u/115872951?v=4",
        linkedin: "https://www.linkedin.com/in/amal-e-a-812464246/",
        github: "https://github.com/Amal911",
      },
   
      {
        name: "Mohammed Rasnal K A",
        img: "https://avatars.githubusercontent.com/u/59244980?s=100&v=4",
        linkedin: "https://www.linkedin.com/in/mohammed-rasnal-k-a-373508221/",
        github: "https://github.com/raznalrich",
      },
      
    ],
  },
  {
      id: 3,
      title: "SARA: The virtual Receptionist",
      date: "",
      description:
        "SARA is a virtual receptionist built to serve at college reception. the application have features such as Face Recognition, Attendance Marking, Navigation, Visitor Notification etc. The project is built as part of BTech Final year major project ",
      image:
        "https://github.com/Amal911/SARA-A-college-Receptionist/raw/master/SARA%20A%20Virtual%20Receptionist.png",
      tags: ["Python", "Django", "SQlite", "HTML", "CSS", "JavaScript", "OpenCV", ],
      category: "web app",
      github: "https://github.com/Amal911/SARA-A-college-Receptionist",
      webapp: "https://github.com/Amal911/SARA-A-college-Receptionist",
      member: [
        {
          name: "Amal E A",
          img: "https://avatars.githubusercontent.com/u/115872951?v=4",
          linkedin: "https://www.linkedin.com/in/amal-e-a-812464246/",
          github: "https://github.com/Amal911",
        },
        {
          name: "Maxen Varghese",
          img: "https://avatars.githubusercontent.com/u/64342680?s=100&v=4",
          linkedin: "https://www.linkedin.com/in/maxenvarghese/",
          github: "https://github.com/Maxen16",
        },
        {
          name: "Mohammed Rasnal K A",
          img: "https://avatars.githubusercontent.com/u/59244980?s=100&v=4",
          linkedin: "https://www.linkedin.com/in/mohammed-rasnal-k-a-373508221/",
          github: "https://github.com/raznalrich",
        },
        {
          name: "Rohith Sekhar N",
          img: "https://avatars.githubusercontent.com/u/96624609?s=100&v=4",
          linkedin: "https://www.linkedin.com/in/rohith-sekhar-n-a9922b22b/",
          github: "https://github.com/RohithSekharN",
        },
      ],
    },
  {
      id: 2,
      title: "Guess The Dice Game",
      date: "",
      description:
        "A simple ReactJS application game in which you collects points if you guess the dice roll correctly",
      image: "https://github.com/Amal911/Dice-Game/raw/main/public/DiceGame.png",
      tags: ["ReactJS", "JavaScript", "Styled Components"],
      category: "web app",
      github: "https://github.com/Amal911/Dice-Game",
      webapp: "https://dice-game-amal911.netlify.app/",
    },
  {
    id: 1,
    title: "Quick Notes",
    date: "",
    description:
      "Quick Notes is a Web App mate to store notes. It is a clone of Google's Keep Notes. The apllication is made with NodeJS as the backend and MongoDB as the Database. ",
    image:
      "https://github.com/Amal911/Quick-Notes/raw/main/public/img/img.png",
    tags: [
      "HTML",
      "CSS",
      "EJS",
      "JavaScript",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
    ],
    category: "web app",
    github: "https://github.com/Amal911/Quick-Notes",
    webapp: "",
  },
]
























// export const TimeLineData = [
//   { year: 2017, text: "Started my journey" },
//   { year: 2018, text: "Worked as a freelance developer" },
//   { year: 2019, text: "Founded JavaScript Mastery" },
//   { year: 2020, text: "Shared my projects with the world" },
//   { year: 2021, text: "Started my own platform" },
// ];
